import { prepareCommonCarriageData, sendCarriage } from "./sendCarriageCommon";
import { type LinearConfigurationUpdate } from "../../Linear/models";
import { prepareApiDataForResetOld, prepareGroupIdToDisplay } from "../../common/commonConfiguratorApi";
import { type LinearConfiguratorState } from "../../Linear/redux/types";

export function sendCarriageDetailsReset(linearState: LinearConfiguratorState): Promise<LinearConfigurationUpdate> {
  const data = prepareCommonCarriageData(linearState);
  const resetData = prepareApiDataForResetOld(linearState);

  data.carriagesConfiguratorData.resetCarriageDetails = true;
  data.carriagesConfiguratorData.enableConfigureCarriageValues = false;

  prepareGroupIdToDisplay(data);

  return sendCarriage({
    ...data,
    ...resetData,
  });
}
